import Vue from 'vue'

$(() => {
  if (!$('.js-multiple-hierarchy-select-modal').length) {
    return
  }

  // memo
  // .js-multiple-hierarchy-select-modal > モーダル
  // .js-multiple-hierarchy-select-modal_wrapper > wrapper
  // .js-multiple-hierarchy-select-modal_open> モーダルを開く
  // .js-multiple-hierarchy-select-modal_value > エリア選択された値を表示するinput
  // .js-multiple-hierarchy-select-modal_params > エリア選択された値のhidden input

  const setupComponent = (id) => {

    const wrapper  = $(id).closest('.js-multiple-hierarchy-select-modal_wrapper')
    const opener = wrapper.find('.js-multiple-hierarchy-select-modal_open')
    const valueInput = wrapper.find('.js-multiple-hierarchy-select-modal_value')

    // // モーダル表示イベント
    opener.on('click', (e) => {
      $(id).modal('show')
    })

    new Vue({
      el: id,
      data: {
        openedChoiceId: "",
        selectedPartIds: [],
        datas: $(id).data('data'), 
      },
      mounted() {
        this.openedChoiceId = this.datas[0].choice.id
        let values = $(id).data('default')
        if (!!values) {
          for (let val of values) {
            if (val) {
              this.selectedPartIds.push(parseInt(val))
            }
          }
        }
        this.updateParams()

        $('.js-object-search-form .js-form-clear').on('click', (e) => {
          // form clear
          this.selectedPartIds = []
          valueInput.val('')
        })
      },
      methods: {
        dispIsSelectedAllPart(parts) {
          for (let part of parts) {
            if (!this.selectedPartIds.includes(part.id)) {
              return false
            }
          }
          return true
        },
        dispSelectedCountInChoice(choiceId) {
          let count = 0
          for (let data of this.datas) {
            if (data.choice.id !== choiceId) {
              continue
            }
            for (let part of data.parts) {
              if (this.selectedPartIds.includes(part.id)) {
                count += 1
              }
            }
          }
          return count
        },
        updateParams() {
          // 表示用
          let values = []
          for (let data of this.datas) {
            for (let part of data.parts) {
              if (this.selectedPartIds.includes(part.id)) {
                values.push(part.name)
              }
            }
          }
          valueInput.val(values.join('、'))
        },
        onSelectChoice(choiceId) {
          this.openedChoiceId = choiceId
        },
        onSelectAllPart(parts) {
          if (this.dispIsSelectedAllPart(parts)) {
            // 既に選択済みの場合はすべてチェック外す
            for (let part of parts) {
              this.selectedPartIds.splice(this.selectedPartIds.indexOf(part.id), 1)
            }
            this.updateParams()
            return
          }

          // 未選択の場合

          for (let part of parts) {
            if (this.selectedPartIds.includes(part.id)) {
              // チェック済みはスキップ
            } else {
              // 未チェックは追加
              this.selectedPartIds.push(part.id)
            }
          }

          // 最後にソート
          this.selectedPartIds.sort((a,b) => {
              if(a.sort > b.sort) return -1;
              if(a.sort < b.sort) return 1;
              return 0;
          });

          this.updateParams()
        },
        onSelectPart(part) {
          if (this.selectedPartIds.includes(part.id)) {
            // チェック済みは削除
            this.selectedPartIds.splice(
              this.selectedPartIds.indexOf(part.id), 1)
          } else {
            // 未チェックは追加
            this.selectedPartIds.push(part.id)
            this.selectedPartIds.sort((a,b) => {
                if(a.sort > b.sort) return -1;
                if(a.sort < b.sort) return 1;
                return 0;
            });
          }
          this.updateParams()
        },
      }
    })
  }


  // 初期化
  $('.js-multiple-hierarchy-select-modal').each((i, element) => {
    let id = $(element).attr('id')
    setupComponent('#' + id)
  })
})
